module.exports = __webpack_public_path__ + "img/common-banner.29c0c6c3.jpg";